export default __webpack_public_path__ + "aa7208b3ce75e789bf7dc1095905ca57.png";